import faker from 'faker'

/**
 * [description]
 * @param  {[type]} text [description]
 * @return {[type]}      [description]
 */
export const slugify = (text) => {
	return faker.helpers.slugify(text.trim().toLowerCase().replace(/[\.\[\]\(\)\+\_]/g, ''))
}